import { useState } from 'react'
import { CalendarRange } from 'lucide-react'
import { PERIOD_PRESETS, useDashboardPeriod } from '../period'

const baseButton = 'rounded-full px-3 py-1 text-xs font-medium transition-colors'
const active = 'bg-primary text-primary-foreground'
const idle = 'bg-muted text-muted-foreground hover:text-foreground'

/** Picks the date range for the money widgets on the Company tab: a preset or a custom range. */
export function PeriodPicker() {
  const { choice, setChoice } = useDashboardPeriod()
  const [from, setFrom] = useState(choice.from ?? '')
  const [to, setTo] = useState(choice.to ?? '')
  const [customOpen, setCustomOpen] = useState(choice.period === 'custom')
  const invalid = !from || !to || from > to

  return (
    <div className="flex flex-wrap items-center gap-2" role="group" aria-label="Period">
      <CalendarRange className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
      {PERIOD_PRESETS.map((preset) => (
        <button
          key={preset.key}
          type="button"
          aria-pressed={choice.period === preset.key}
          className={`${baseButton} ${choice.period === preset.key ? active : idle}`}
          onClick={() => {
            setCustomOpen(false)
            setChoice({ period: preset.key })
          }}
        >
          {preset.label}
        </button>
      ))}
      <button
        type="button"
        aria-pressed={choice.period === 'custom'}
        aria-expanded={customOpen}
        className={`${baseButton} ${choice.period === 'custom' ? active : idle}`}
        onClick={() => setCustomOpen((open) => !open)}
      >
        Custom
      </button>
      {customOpen && (
        <span className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
          <label className="flex items-center gap-1">
            From
            <input
              type="date"
              value={from}
              max={to || undefined}
              onChange={(e) => setFrom(e.target.value)}
              className="rounded-md border border-input bg-background px-2 py-1 text-xs text-foreground"
            />
          </label>
          <label className="flex items-center gap-1">
            To
            <input
              type="date"
              value={to}
              min={from || undefined}
              onChange={(e) => setTo(e.target.value)}
              className="rounded-md border border-input bg-background px-2 py-1 text-xs text-foreground"
            />
          </label>
          <button
            type="button"
            disabled={invalid}
            className={`${baseButton} ${invalid ? 'cursor-not-allowed bg-muted text-muted-foreground/60' : active}`}
            onClick={() => setChoice({ period: 'custom', from, to })}
          >
            Apply
          </button>
        </span>
      )}
    </div>
  )
}
